<form [formGroup]="customerForm"  class="">
    <div class=" scrollbar longtab">
        <div class=" ">
            <div class="cst-acc-card mb20">
                <div class="row">
                    <div class="col-3 mt-3" *ngIf="allowQuickSearch">
                        <label for="template-firstName" translate>&nbsp;</label>
                        <div class='lbl-info'>
                            <div *ngIf="!customerId" class="input-group">
                                <input class="form-control" type="text" name="searchTerm"
                                    placeholder="{{ 'lblQuicksearch' | translate }}" [(ngModel)]="search"
                                    [ngModelOptions]="{standalone: true}" autocomplete="off"
                                    (keyup.enter)="onSearchFilter()" *ngIf="allowQuickSearch" />
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-primary" (click)="onSearchFilter()"
                                        aria-label="Center Align" *ngIf="allowQuickSearch">
                                        <em class="fa fa-search" aria-hidden="true" *ngIf="allowQuickSearch"></em>
                                    </button>
                                    <button type="button" class="btn btn-primary" (click)="onAdvanceSearch()"
                                        aria-label="Center Align" style="margin-left: 1px; border-top-right-radius: 3px; border-bottom-right-radius: 3px;" *ngIf="allowQuickSearch">
                                        <em class="fa fa-search-plus" aria-hidden="true" *ngIf="allowQuickSearch"></em>
                                    </button>
                                    
                                </div>

                                <div class="searchbox card fix" *ngIf="isAdvanceSearch">
                                    <div class="form-row mt-3">
                                        <div class="col-6 mb-3">
                                            <label translate>lblDateOfBirth</label>
                                            <div class="lbl-info cal-date">
                                                <input class="form-control datePicker width100force" appAfDatepicker
                                                    autocomplete="off" [(ngModel)]="advanceSearchRequest.birthDate"
                                                    [startDate]="'1900/01/01'" [dateTime]="false" id="BirthDate"
                                                    name="BirthDate" type="text" value="" [endDate]="endDate"
                                                    [ngModelOptions]="{standalone: true}">
                                                <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                                            </div>
                                        </div>
                                        <div class="col-6 mb-3">
                                            <label for="template-customerName" translate>lblFullName </label>
                                            <div class='lbl-info'>
                                                <input type="text" id="template-customerName" name="customerName"
                                                    [(ngModel)]="advanceSearchRequest.customerName"
                                                    [ngModelOptions]="{standalone: true}" class="form-control"
                                                    maxlength="100">
                                            </div>
                                        </div>
                                        <div class="col-6 mb-3">
                                            <label for="template-postcode" translate>lblPostCode</label>
                                            <div class='lbl-info'>
                                                <ng-select name="postCode"
                                                    placeholder="{{ 'lblSelectPostCode' | translate }}"
                                                    [(ngModel)]="advanceSearchRequest.postCode"
                                                    [ngModelOptions]="{standalone: true}" [virtualScroll]="true">
                                                    <ng-option *ngFor="let item of postCodeList"
                                                        [value]="item.code">
                                                        {{item.code}}</ng-option>
                                                </ng-select>
                                            </div>
                                        </div>


                                    
                                        <div class="col-6 mb-3">
                                            <label for="template-mobile" translate>lblMobile</label>
                                            <input type="text" id="template-mobile" name="mobile"
                                                [(ngModel)]="advanceSearchRequest.mobile"
                                                [ngModelOptions]="{standalone: true}" class="form-control" />

                                        </div>
                                    </div>
                                    <hr />
                                    <div class="row">
                                        <div class="col text-right">
                                            <button type="submit" (click)="onApplyAdvanceSearch()"
                                                class="btn btn-primary mr-sm-3" translate>lblApply
                                            </button>
                                            <button (click)="onResetAdvanceSearch()"
                                                class="btn btn-outline-tertiary mr-sm-3" translate>lblReset
                                            </button>
                                            <button (click)="onCloseAdvanceSearch()"
                                                class="btn btn-outline-tertiary" translate>lblClose
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 mt-3 space-between">
                        <div class="custom-control custom-checkbox mt-25"  *ngIf="allowCompanyCreation">
                            <input class="custom-control-input" type="checkbox" [checked]="companyShow"
                                id="customCheck1"  (change)="changeCustomerType($event)"/>
                            <label class="custom-control-label" style="line-height: 25px;" for="customCheck1"
                                translate>lblCompany</label>                            
                        </div>
                        <div *ngIf="!companyShow" class="mt-25" style="margin-right:26px ;">
                            <div class="col-auto">
                                <div class="  p-0">
                                    <input type="radio" id="Male" formControlName="gender" value="0" name="gender"
                                    class="radio-custom" />
                                    <label class="form-check-label" style="line-height: 25px;"  for="Male" translate>lblMale</label>
                                </div>
                            </div>
                            <div class="col-auto">
                                <div class="  p-0">
                                    <input type="radio" id="Female"  formControlName="gender" value="1" name="gender" 
                                    class="radio-custom" />
                                    <label class="form-check-label" style="line-height: 25px;"  for="Female" translate>lblFemale</label>
                                </div>
                            </div>
                        </div> 
                    </div>
                    <div class="col-3 mt-3" *ngIf="allowAccount && companyShow">
                        <div class="custom-control custom-checkbox mt-25">
                            <input class="custom-control-input" type="checkbox" [checked]="accountShow"
                                id="accountsCheck" (change)="changeAccount($event)"
                                formControlName="isAccountHolderCompany"  (change)="changeIsAccountHolderCompany($event)"/>
                            <label class="custom-control-label" style="line-height: 25px;" for="accountsCheck"
                                translate>lblAccountHolderCompany</label>
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="companyShow">
                        <label for="template-custName" translate>lblCompanyName </label><strong
                            *ngIf="isCompanynameRequired" class="mlt6 required"> *
                        </strong>
                        <div class='lbl-info'>
                            <input type="text" id="template-custName" name="custName" formControlName="custName"
                                class="form-control" placeholder="{{ 'lblEnterCompanyName' | translate }}"
                                maxlength="100"
                                [ngClass]="{'ng-select-is-invalid':(cpf.custName.invalid) || (cpf.custName.invalid  && isFormValid)}">
                            <div *ngIf="(isCompanynameRequired && (cpf.custName.invalid) || (cpf.custName.invalid  && isFormValid))"
                                class="help-block text-danger">
                                <div *ngIf="isCompanynameRequired && cpf.custName.errors.required"><span
                                        translate>lblRequiredCompanyName</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="!companyShow">
                        <label for="template-firstName" translate>lblFirstName</label><strong class="mlt6 required"> *
                        </strong>
                        <div class='lbl-info'>
                            <input type="text" id="template-firstName" name="firstName" formControlName="firstName"
                                class="form-control" placeholder="{{ 'lblEnterFirstName' | translate }}" required
                                maxlength="50"
                                [ngClass]="{'ng-select-is-invalid':(cpf.firstName.invalid )|| (cpf.firstName.invalid && isFormValid )}"
                                >
                            <div *ngIf="(cpf.firstName.invalid ) || (cpf.firstName.invalid && isFormValid ) "
                                class="help-block text-danger">
                                <div *ngIf="cpf.firstName.errors.required"><span translate>lblRequiredFirstName</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="!companyShow">
                        <label for="template-lastName" translate>lblLastName</label><strong class="mlt6 required"> *
                        </strong>
                        <div class='lbl-info'>
                            <input type="text" id="template-lastName" name="lastName" formControlName="lastName"
                                class="form-control" placeholder="{{ 'lbEnterlLastName' | translate }}" required
                                maxlength="50"
                                [ngClass]="{'ng-select-is-invalid':(cpf.lastName.invalid) || (cpf.lastName.invalid  && isFormValid)}">
                            <div *ngIf="(cpf.lastName.invalid) || (cpf.lastName.invalid  && isFormValid)  "
                                class="help-block text-danger">
                                <div *ngIf="cpf.lastName.errors.required"><span translate>lbRequiredlLastName</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 mt-3">
                        <label for="template-customergroup" translate>lblCustomerGroup<strong
                                *ngIf="iscustomergroupRequired" class="mlt6 required">
                                *</strong> </label>
                        <div class='lbl-info'>
                            <ng-select formControlName="customergroup"
                                placeholder="{{ 'lblSelectCustomerGroup' | translate }}" [(ngModel)]="customergroupName"
                                [ngClass]="{'ng-select-is-invalid':(cpf.customergroup.invalid ) || (cpf.customergroup.invalid  && isFormValid)}">
                                <ng-template ng-header-tmp>
                                    <span class="mbold w-66px">Code</span>
                                    <span class="mbold" translate>lblCustomerGroup</span>
                                </ng-template>
                                <ng-option *ngFor="let item of customerGroupList" [value]="item.code">
                                    <span class="w-66px">{{item.code}}</span>
                                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                    <span>{{item.description}}</span>
                                </ng-option>
                            </ng-select>
                            <div *ngIf="iscustomergroupRequired && (cpf.customergroup.invalid ) || (cpf.customergroup.invalid && isFormValid)"
                                class="help-block text-danger">
                                <div *ngIf="iscustomergroupRequired && cpf.customergroup.errors.required"><span
                                        translate>lblRequiredCustomerGroup</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="companyShow">
                        <label for="template-registrationNumber" translate>lblRegNumber</label>
                        <div class='lbl-info'>
                            <input type="text" id="template-registrationNumber" name="registrationNumber"
                                formControlName="registrationNumber" class="form-control"
                                placeholder="{{ 'lblEnterRegistrationNumber' | translate }}" maxlength="20">
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="companyShow">
                        <label for="txtregistrationDate" translate>lblRegistrationDate</label>
                        <div class="lbl-info cal-date">
                            <input class="form-control datePicker width100force" appAfDatepicker 
                                [(ngModel)]="registrationDate" autocomplete="off" [startDate]="'1900/01/01'"
                                [dateTime]="false" id="txtregistrationDate" formControlName="registrationDate"
                                name="registrationDate" type="text" value="" [endDate]="endDate">
                            <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="!companyShow">
                        <label for="txtdateOfBirth" translate>lblDateOfBirth </label>
                        <div class="lbl-info cal-date ">
                            <input class="form-control datePicker width100force" appAfDatepicker 
                                [(ngModel)]="dateOfBirth" autocomplete="off" [startDate]="'1900/01/01'"
                                [dateTime]="false" id="txtdateOfBirth" formControlName="dateOfBirth" name="dateOfBirth"
                                type="text" value="" [endDate]="endDate">
                            <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="!hideExtraInformation">
                        <label for="template-salutation" translate>lblSalutation</label>
                        <div class='lbl-info'>
                            <ng-select formControlName="salutation" 
                                placeholder="{{ 'lblSelectSalutation' | translate }}" [(ngModel)]="salutationName">
                                <ng-template ng-header-tmp>
                                    <span class="mbold w-66px">Code</span>
                                    <span class="mbold" translate>lblSalutation</span>
                                </ng-template>

                                <ng-option *ngFor="let item of addressSalutationList" [value]="item.code">
                                    <span class="w-66px">{{item.code}}</span>
                                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                    <span>{{item.description}}</span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="allowAccount && isShowAccountCompanyName">
                        <label for="template-accountCompanyName" translate>lblAccountCompanyName</label>
                        <ng-select placeholder="Enter Account Name to search" [(ngModel)]="accountCompanyName"
                            [ngModelOptions]="{standalone: true}" (keyup)="accountValueChange($event.target.value)"
                            (change)="selectEvent($event)">
                            <ng-option *ngFor="let supplier of filterAccountList" [value]="supplier.accountNo">
                                {{supplier.accountName}}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="col-3 mt-3">
                        <label for="template-customerNo" translate>lblCustomerNumber</label>
                        <input type="text" id="template-customerNo" name="customerNo" formControlName="customerNo"
                            class="form-control" [attr.disabled]="true" />
                    </div>
                    <div class="col-3 mt-3" *ngIf="hideExtraInformation">
                        <div class="af-form-group mt-4">
                            <div class="custom-control custom-switch mt-0">
                                <input type="checkbox" class="custom-control-input" id="isMinBilUser"
                                    formControlName="isMinBilUser">
                                <label class="custom-control-label" for="isMinBilUser" translate>lblIsMinBilUser</label>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-3 mt-3" *ngIf="hideExtraInformation">
                        <label for="template-navisionId">Navision Id</label>
                        <input type="text" id="template-navisionId" name="navisionId" formControlName="navisionId"
                            class="form-control" [attr.disabled]="true" />
                    </div>
                    <div class="col-3 mt-3" *ngIf="hideExtraInformation">
                        <label for="template-cbid">CBID</label>
                        <input type="text" id="template-cbid" name="cbid" formControlName="cbid"
                            class="form-control" [attr.disabled]="true" />
                    </div>
                    <div class="col-3 mt-3" *ngIf="!hideExtraInformation">
                        <label for="template-dealerId" translate>lblDealersName</label>
                        <div class='lbl-info'>
                            <ng-select formControlName="dealerId"
                                placeholder="{{ 'lblDealersName' | translate }}" [(ngModel)]="dealerSelected">
                                <ng-option *ngFor="let item of dealerList" [value]="item.dealerId">
                                    <span>{{item.dealerName}}</span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="!hidePaymentDetails">
                        <label for="template-paymentMethodCode" translate>lblPaymentMethod</label>
                        <div class='lbl-info'>
                            <ng-select formControlName="paymentMethodCode"
                                placeholder="{{ 'lblSelectPaymentMethod' | translate }}" [(ngModel)]="paymentMethodCode">
                                <ng-template ng-header-tmp>
                                    <span class="mbold w-66px">Code</span>
                                    <span class="mbold" translate>lblPaymentMethod</span>
                                </ng-template>

                                <ng-option *ngFor="let item of paymentMethodList" [value]="item.paymentCode">
                                    <span class="w-66px">{{item.paymentCode}}</span>
                                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                    <span>{{item.paymentDescription}}</span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="!hidePaymentDetails">
                        <label for="template-paymentTermsCode" translate>lblPaymentTerms</label>
                        <div class='lbl-info'>
                            <ng-select formControlName="paymentTermsCode" 
                                placeholder="{{ 'lblSelectPaymentTerms' | translate }}" [(ngModel)]="paymentTermsCode">
                                <ng-template ng-header-tmp>
                                    <span class="mbold w-66px" translate>lblCode</span>
                                    <span class="mbold" translate>lblPaymentTerms</span>
                                </ng-template>

                                <ng-option *ngFor="let item of paymentTermsList" [value]="item.paymentTermCode">
                                    <span class="w-66px">{{item.paymentTermCode}}</span>
                                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                    <span>{{item.paymentTermDescription}}</span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="!hidePaymentDetails">
                        <label for="template-reminderTermsCode" translate>lblReminderTerms</label>
                        <div class='lbl-info'>
                            <ng-select formControlName="reminderTermsCode" 
                                placeholder="{{ 'lblSelectReminderTerms' | translate }}" [(ngModel)]="reminderTermsCode">
                                <ng-template ng-header-tmp>
                                    <span class="mbold w-66px" translate>lblCode</span>
                                    <span class="mbold" translate>lblReminderTerms</span>
                                </ng-template>

                                <ng-option *ngFor="let item of reminderTermsList" [value]="item.reminderTermCode">
                                    <span class="w-66px">{{item.reminderTermCode}}</span>
                                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                    <span>{{item.reminderTermDescription}}</span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="!hidePaymentDetails">
                        <label for="template-laborPriceGroupCode" translate>lblLaborPriceGroup</label>
                        <div class='lbl-info'>
                            <ng-select formControlName="laborPriceGroup" 
                                placeholder="{{ 'lblSelectLaborPriceGroup' | translate }}" [(ngModel)]="laborPriceGroup">
                                <ng-template ng-header-tmp>
                                    <span class="mbold w-66px" translate>lblCode</span>
                                    <span class="mbold" translate>lblLaborPriceGroup</span>
                                </ng-template>

                                <ng-option *ngFor="let item of laborAndItemSalesPriceList?.laborGroupPrice" [value]="item.code">
                                    <span class="w-66px">{{item.code}}</span>
                                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                    <span>{{item.description}}</span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="!hidePaymentDetails">
                        <label for="template-itemSalesPriceGroupCode" translate>lblItemSalesPriceGroup</label>
                        <div class='lbl-info'>
                            <ng-select formControlName="itemSalesPriceGroup" 
                                placeholder="{{ 'lblSelectItemSalesPriceGroup' | translate }}" [(ngModel)]="itemSalesPriceGroup" >
                                <ng-template ng-header-tmp>
                                    <span class="mbold w-66px" translate>lblCode</span>
                                    <span class="mbold" translate>lblItemSalesPriceGroup</span>
                                </ng-template>

                                <ng-option *ngFor="let item of laborAndItemSalesPriceList?.itemSalesPrice" [value]="item.code">
                                    <span class="w-66px">{{item.code}}</span>
                                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                    <span>{{item.description}}</span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="!hidePaymentDetails">
                    <div class="custom-control custom-checkbox mt-21" >
                        <input class="custom-control-input" type="checkbox" [checked]="isVatApplyOnDemandDefault" id="customCheck2"
                            (change)="changeVatApplyOnDemand($event)" [disabled]="(customerId == 0 || customerId > 0)"/>
                        <label class="custom-control-label" for="customCheck2" translate>lblIsVatApplyOnDemand</label>
                    </div>
                    </div>
                    <div class="col-3 mt-3" *ngIf="!companyShow" style="display: none;">
                        <label for="template-personNumber" translate>lblPersonNumber</label>
                        <div class='lbl-info'>
                            <input type="text" id="template-personNumber" name="personNumber"
                                formControlName="personNumber" class="form-control"
                                placeholder="{{ 'lblEnterPersonNumber' | translate }}" maxlength="20">
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-6 mt-3">
                      <div class="af-form-group">
                        <label for="remark" translate>lblRemark</label>
                        <div class="lbl-info relative">
                          <textarea class="form-control remark-highlight" id="remark" name="remark" formControlName="remark" maxlength="1000">
                          </textarea>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="cst-acc-card mb20">
                <div class="row">
                    <div class="col-3">
                        <label for="template-address1" translate>lblAddress1</label><strong class="mlt6 required"> *
                        </strong>
                        <div class='lbl-info'>
                            <input type="text" id="template-address1" name="address1" formControlName="address1"
                                class="form-control" placeholder="{{ 'lblEnterAddressLine 1' | translate }}" required
                                maxlength="100"
                                [ngClass]="{'ng-select-is-invalid':(cpf.address1.invalid) || (cpf.address1.invalid  && isFormValid)}">
                            <div *ngIf="(cpf.address1.invalid)  || (cpf.address1.invalid  && isFormValid) "
                                class="help-block text-danger">
                                <div *ngIf="cpf.address1.errors.required"><span translate>lblAddressLine1Required</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <label for="template-address2" translate>lblAddress2</label>
                        <div class='lbl-info'>
                            <input type="text" id="template-address2" name="address2" formControlName="address2"
                                class="form-control" placeholder="{{ 'lblEnterAddressLine 2' | translate }}"
                                maxlength="100">
                        </div>
                    </div>
                    <div class="col-3">
                        <label for="template-postcode" translate>lblPostCode<strong *ngIf="ispostcodeRequired"
                                class="mlt6 required"> *</strong> </label>
                        <div class='lbl-info'>
                            <ng-select formControlName="postcode" placeholder="{{ 'lblSelectPostCode' | translate }}"
                                [virtualScroll]="true" [(ngModel)]="postcodeName" (change)="onPostCodeSelected($event)"
                                [ngClass]="{'ng-select-is-invalid':(cpf.postcode.invalid) || (cpf.postcode.invalid  && isFormValid)}">
                                <ng-option *ngFor="let item of postCodeList" [value]="item.code">
                                    {{item.code}}</ng-option>
                            </ng-select>
                            <div *ngIf="ispostcodeRequired && ((cpf.postcode.invalid ) || (cpf.postcode.invalid && isFormValid))  "
                                class="help-block text-danger">
                                <div *ngIf="cpf.postcode.errors.required"><span translate>lblRequiredPostCode</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <label for="template-city" translate>lblCity<strong *ngIf="iscityRequired"
                                class="mlt6 required"> *</strong> </label>
                        <div class='lbl-info'>
                            <ng-select formControlName="city" placeholder="{{ 'lblSelectCity' | translate }}"
                                [(ngModel)]="cityName" (change)="onCitySelected($event)"
                                [ngClass]="{'ng-select-is-invalid':(cpf.city.invalid) || (cpf.city.invalid  && isFormValid)}">
                                <ng-option *ngFor="let item of cityList" [value]="item">
                                    {{item}}</ng-option>
                            </ng-select>
                            <div *ngIf="(iscityRequired && (cpf.city.invalid)  || (cpf.city.invalid && isFormValid)) "
                                class="help-block text-danger">
                                <div *ngIf="cpf.city.errors.required "><span translate>lblRequiredCity</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-3">
                        <label for="template-country" translate>lblCountry<strong *ngIf="iscountryRequired"
                                class="mlt6 required"> *</strong> </label>
                        <div class='lbl-info'>
                            <ng-select formControlName="country" placeholder="{{ 'lblSelectCountry' | translate }}"
                                [(ngModel)]="countryName" (change)="onselectCountry($event)"
                                [ngClass]="{'ng-select-is-invalid': (cpf.country.invalid  && isFormValid)}">
                                <ng-option *ngFor="let item of countryList" [value]="item.id">
                                    {{item.countryName}}</ng-option>
                            </ng-select>
                            <div *ngIf="(iscountryRequired && (cpf.country.invalid)  || (cpf.country.invalid && isFormValid)) "
                                class="help-block text-danger">
                                <div *ngIf="cpf.country.errors.required"><span translate>lblCountryIsRequired</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <label for="email"><span translate>lblEmail</span>
                        </label>
                        <div class="lbl-info">
                            <input formControlName="email" maxlength="50"
                                [ngClass]="{'ng-select-is-invalid': ( cpf.email.errors) || (cpf.email.invalid && isFormValid)}"
                                class="form-control mb-2" placeholder="{{ 'lblEnterEmail' | translate }}">
                            <div
                                *ngIf="( cpf.email.errors) || (cpf.email.invalid && isFormValid)">
                                <div *ngIf="cpf.email.errors.pattern" class="help-block mt-1 text-danger" translate>
                                    lblEnterValidEmail
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3" *ngIf="!hideExtraInformation">
                        <label for="email2"><span translate>lblEmail 2</span>
                        </label>
                        <div class="lbl-info">
                            <input formControlName="email2" maxlength="50"
                                [ngClass]="{'is-invalid': (cpf.email2.touched || cpf.email2.dirty) && cpf.email2.errors }"
                                class="form-control mb-2" placeholder="{{ 'lblEnterEmail' | translate }}">
                            <div *ngIf="(cpf.email2.touched || cpf.email2.dirty) && cpf.email2.errors">
                                <div *ngIf="cpf.email2.errors.pattern" class="help-block mt-1 text-danger" translate>
                                    lblEnterValidEmail
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3" style="display: none;">
                        <label for="fax"><span translate>lblFax</span>
                        </label>
                        <div class="lbl-info">
                            <input formControlName="fax" maxlength="15" (keypress)="isDigit($event)"
                                [ngClass]="{'is-invalid': (cpf.fax.touched || cpf.fax.dirty) && cpf.fax.errors}"
                                class="form-control mb-2" placeholder="{{ 'lblEnterFax' | translate }}">
                            <div *ngIf="(cpf.fax.touched || cpf.fax.dirty) && cpf.fax.errors">
                                <div *ngIf="cpf.fax.errors.pattern" class="help-block mt-1 text-danger" translate>
                                    lblValidFax
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <label for="mobile"><span translate>lblMobile</span><strong class="mlt6 required"> *</strong>
                        </label>
                        <div class="lbl-info">
                            <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="mobile" [cssClass]="{'form-control': true, 'ng-select-is-invalid': ( cpf.mobile.errors) || (cpf.mobile.invalid && isFormValid)}"
                                [(selectedCountryISO)]="selectedCountryISOMobile" [maxLength]="15" [phoneValidation]="false" (keyup)="onMobileChange()"
                                [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"  [customPlaceholder]="'lblEnterMobile' | translate"
                                (countryChange)="onCountryChange($event)" required>
                            </ngx-intl-tel-input>
                            <div
                                *ngIf="( cpf.mobile.errors) || (cpf.mobile.invalid && isFormValid)">
                                <div *ngIf="cpf.mobile.errors.required" class="help-block mt-1 text-danger" translate>
                                    lblMobileRequired
                                </div>
                                <div *ngIf="cpf.mobile.errors.pattern" class="help-block mt-1 text-danger" translate>
                                    lblEnterValidMobile
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">

                    <div class="col-3">
                        <label for="landline"><span translate>lblPhoneNumber</span>
                        </label>
                        <div class="lbl-info">
                            <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="landline" [cssClass]="{'form-control': true, 'is-invalid': (cpf.landline.touched || cpf.landline.dirty) && cpf.landline.errors}"
                            [selectedCountryISO]="selectedCountryISOLandline" [maxLength]="15" [phoneValidation]="false"
                            [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"  [customPlaceholder]="'lblPhoneNumber' | translate"
                            (countryChange)="onCountryChangeLandline($event)" (keyup)="onLandlineChange()"
                            ></ngx-intl-tel-input>
                            <div *ngIf="( (cpf.landline.touched || cpf.landline.dirty) && cpf.landline.errors) || (cpf.landline.invalid && isFormValid)">
                                <div *ngIf="cpf.landline.errors.pattern" class="help-block mt-1 text-danger" translate>
                                    lblEnterValidPhoneNumber
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 mt-2">
                        <div class="af-form-group mt-4">
                            <div class="custom-control custom-switch mt-0">
                                <input type="checkbox" class="custom-control-input" id="isActive"
                                    formControlName="isActive">
                                <label class="custom-control-label" for="isActive" translate>lblActive</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cst-acc-card mb20">
                <div class="row">
                    <div class="col-12 mb-3">
                        <div class="af-form-group">
                            <div class="custom-control custom-switch mt-0">
                                <input type="checkbox" class="custom-control-input" id="IsMarketingConsent"
                                    formControlName="IsMarketingConsent" (change)="checkMarketingConsentValue($event)">
                                <label class="custom-control-label titleS16 text-primary" for="IsMarketingConsent"
                                    translate>lblMarketingConsent</label>
                            </div>
                        </div>
                    </div>
                   
                    <div class="col-3" *ngIf="!hideExtraInformation">
                        <div class="af-form-group">
                            <div class="custom-control custom-switch mt-0">
                                <input type="checkbox" class="custom-control-input" id="isRegularEmail"
                                    formControlName="isRegularEmail" (change)="checkMarketingValue($event)">
                                <label class="custom-control-label" for="isRegularEmail"
                                    translate>lblSendingPostCardAllowed</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="af-form-group">

                            <div class="custom-control custom-switch mt-0">
                                <input type="checkbox" class="custom-control-input" id="isEmail"
                                    formControlName="isEmail" (change)="checkMarketingValue($event)">
                                <label class="custom-control-label" for="isEmail" translate>lblEmail
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-2" style="display: none;">
                        <div class="af-form-group">
                            <div class="custom-control custom-switch mt-0">
                                <input type="checkbox" class="custom-control-input" id="isFax" formControlName="isFax" (change)="checkMarketingValue($event)">
                                <label class="custom-control-label" for="isFax" translate>lblFax</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="af-form-group">
                            <div class="custom-control custom-switch mt-0">
                                <input type="checkbox" class="custom-control-input" id="isSms" formControlName="isSms" (change)="checkMarketingValue($event)">
                                <label class="custom-control-label" for="isSms" translate>lblSms</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-2" *ngIf="!hideExtraInformation">
                        <div class="af-form-group">
                            <div class="custom-control custom-switch mt-0">
                                <input type="checkbox" class="custom-control-input" id="isPhone"
                                    formControlName="isPhone" (change)="checkMarketingValue($event)">
                                <label class="custom-control-label" for="isPhone" translate>lblPhone</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-3" *ngIf="false">
                        <div class="af-form-group">
                            <div class="custom-control custom-switch mt-0">
                                <input type="checkbox" class="custom-control-input" id="contactID"
                                    formControlName="contactID">
                                <label class="custom-control-label titleS16 text-primary" for="contactID"
                                    translate>lblMarketingConsent</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cst-acc-card mb20" *ngIf="!hideExtraInformation">
                <div class="row">
                    <div class="col-12 mb-3">
                        <div class="af-form-group">
                            <div class="custom-control custom-switch mt-0">
                                <input type="checkbox" class="custom-control-input" id="customerDisagreement"
                                    formControlName="customerDisagreement">
                                <label class="custom-control-label titleS16 text-primary" for="customerDisagreement"
                                    translate>lblMaintenanceReminder</label>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>

            <div class="cst-acc-card mb20">
                <div class="row">
                    <div class="col-12 mb-3">
                        <label for="PrivacyConsentLog" class="mb-2" translate>lblPrivacyConsentLog</label>
                        <div class="table-responsive tableMx-15">
                            <table class="tablest1" aria-describedby="PrivacyConsentLog">
                                <thead>
                                    <tr>
                                        <th scope="col" style="width: 200;" translate>lblStatusPrivacyPolicy</th>
                                        <th scope="col" class="text-center" style="width: 200;" translate>lblSignatureDate</th>
                                        <th scope="col" class="text-center" style="width: 200;" *ngIf="!hideExtraInformation" translate>lblSendingPostCardAllowed
                                        </th>
                                        <th scope="col" class="text-center" style="width: 100;" translate>lblEmail</th>
                                        <th scope="col" class="text-center" style="width: 100;" translate>lblSms</th>
                                        <th scope="col" class="text-center" style="width: 100;" *ngIf="!hideExtraInformation" translate>lblPhone</th>
                                        <th scope="col" class="text-center" style="width: 100;" *ngIf="!hideExtraInformation" translate>lblMaintenanceReminder
                                        </th>
                                        <th scope="col" class="text-center" style="width: 100;" translate *ngIf="!isBNH">lblMarketingConsent</th>
                                        <th scope="col" class="text-center" style="width: 200;" translate>lblLastModification</th>
                                        <th scope="col" class="text-center" style="width: 100;" translate>lblUpdatedBy</th>
                                        <th scope="col" class="text-center" style="width: 100;" translate>lblApplication</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="customerLogDetails?.length>0; else load_NotFound_Template">
                                        <tr *ngFor="let item of customerLogDetails; let i=index">
                                            <td>{{ item.dataPrivacyStatus }}</td>
                                            <td>{{ item.signatureDate | date:'shortDate'}}</td>
                                            <td class="text-center" *ngIf="!hideExtraInformation">
                                                <div class="p-0 form-check">
                                                    <input type="checkbox" [checked]="item.isRegularEmail" id="isRegularEmail"
                                                        disabled />
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div class="p-0 form-check">
                                                    <input type="checkbox" [checked]="item.isEmail" id="isEmail" disabled />
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div class="p-0 form-check">
                                                    <input type="checkbox" [checked]="item.isSms" id="isSms" disabled />
                                                </div>
                                            </td>
                                            <td class="text-center" *ngIf="!hideExtraInformation">
                                                <div class="p-0 form-check">
                                                    <input type="checkbox" [checked]="item.isPhone" id="isPhone" disabled />
                                                </div>
                                            </td>
                                            <td class="text-center" *ngIf="!hideExtraInformation">
                                                <div class="p-0 form-check">
                                                    <input type="checkbox" [checked]="item.isCustomerDisagreement"
                                                        id="isCustomerDisagreement" disabled />
                                                </div>
                                            </td>
                                            <td class="text-center" *ngIf="!isBNH">
                                                <div class="p-0 form-check">
                                                    <input type="checkbox" [checked]="item.isMarketingConsent" id="isMarketingConsent" disabled />
                                                </div>
                                            </td>
                                            <td class="text-center">{{ item.lastUpdatedDate | date:'short'}}</td>
                                            <td class="text-center">{{ item.updatedBy }}</td>
                                            <td class="text-center">{{ item.applicationName }}</td>
                                        </tr>
                                    </ng-container>
                                    <ng-template #load_NotFound_Template>
                                        <tr>
                                            <td colspan="11" class="no-record" translate>lblNoRecordsFound</td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                            </table>
                        </div>
            
                    </div>
                </div>
            
            </div>


          
        </div>
    </div>
    <div class="p-3 bg-light pp-footer-top-brdr">
        <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">

                <button type="button" class="btn btn-primary btn-lg " translate *ngIf="fromVehicleCustomerDetails == false"
                (click)="SaveButtonEvent(false)" [disabled]="this.customerForm.invalid" >
                    <em class="far fa-save font16 align-top mr-2"></em>
                    <ng-container *ngIf="customerId === 0;else load_else ">
                        lblSave
                    </ng-container>
                    <ng-template #load_else>
                        lblSave
                    </ng-template>

                </button>

                <ng-container *ngIf="customerId !== 0 ">
                    <button type="button" class="btn btn-primary btn-lg ml-3" translate *ngIf="fromVehicleCustomerDetails == false"
                        (click)="SaveButtonEvent(true)" [disabled]="this.customerForm.invalid">
                        <em class="far fa-save font16 align-top mr-2"></em>
                        lblSaveAndClose
                    </button>
                </ng-container>

                <ng-container *ngIf="isFromServiceAdvisor == false && fromVehicleScreen != true  && fromVehicleCustomerDetails == false">
                    <button type="button" class="btn btn-primary btn-lg  ml-3"
                        (click)="showVehileAndOtherDetailsTabsFn()" translate [disabled]="this.customerForm.invalid">
                        <em class="far fa-save font16 align-top mr-2"></em>
                        lblSaveAndAddVehicle
                    </button>
                </ng-container>
                <a (click)="OnClose()" class="btn btn-secondary btn-lg ml-3" translate>
                    <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
            </div>
        </div>
    </div>
</form>

<ng-template #customerDuplication let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblExistingCustomerList</h4>
        <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
            (click)="modal.dismiss(false)">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="card pad15">
            <div class="row mt-2" *ngIf="duplicateCustomerList && duplicateCustomerList.length>0">
                <span translate>lblExistingCustomerLists</span>
                    <table>
                        <thead>
                            <tr>
                                <th translate>lblName</th>
                                <th translate>lblCustomerNumber</th>
                                <th translate>lblMatchingType</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let customer of duplicateCustomerList">
                                <td>
                                    <label translate class="ml-2">
                                        {{customer.customerName}}
                                    </label>
                                </td>
                                <td>
                                    <label translate class="ml-2">
                                        {{customer.customerNumber}}
                                    </label>
                                </td>
                                <td>
                                    <label translate class="ml-2">
                                        {{customer.matchType}}
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2" translate
                aria-label="Center Align" (click)="modal.dismiss(true)">lblUpdate</button>
            <button (click)="modal.dismiss(false)" class="btn btn-secondary" aria-label="Center Align"
                translate>lblCancel</button>
        </div>
    </div>
</ng-template>